import { ThemeEvents } from '@theme/events';

function closeSiblingBeeDetails(openDetails)
{
   if (!openDetails.open) return;

   const accordion = openDetails.closest('.bee-accordion');

   if (!accordion) return;

   accordion.querySelectorAll('.bee-details[open]').forEach((details) =>
   {
      if (details !== openDetails) {
         details.removeAttribute('open');
      }
   });
}

function normalizeBeeAccordions(root = document)
{
   root.querySelectorAll('.bee-accordion').forEach((accordion) =>
   {
      const openDetails = accordion.querySelectorAll('.bee-details[open]');

      openDetails.forEach((details, index) =>
      {
         if (index > 0) {
            details.removeAttribute('open');
         }
      });
   });
}

function syncBeeDetailsFromVariantHtml(event)
{
   const html = event.detail?.data?.html;

   if (!html) return;

   document.querySelectorAll('.bee-details[data-content-source="variant_metafield"]').forEach((currentBlock) =>
   {
      const blockId = currentBlock.dataset.beeDetailsId;

      if (!blockId) return;

      const nextBlock = html.querySelector(`.bee-details[data-bee-details-id="${blockId}"]`);
      const currentContent = currentBlock.querySelector('.bee-details__content__inner');
      const nextContent = nextBlock?.querySelector('.bee-details__content__inner');

      if (!currentContent || !nextContent) return;

      currentContent.innerHTML = nextContent.innerHTML;
   });
}

document.addEventListener('toggle', (event) =>
{
   if (!event.target.matches('.bee-details')) return;

   closeSiblingBeeDetails(event.target);
}, true);

document.addEventListener('DOMContentLoaded', () => normalizeBeeAccordions());
document.addEventListener('shopify:section:load', (event) => normalizeBeeAccordions(event.target));
document.addEventListener(ThemeEvents.variantUpdate, syncBeeDetailsFromVariantHtml);
